import { cn } from "@/lib/utils";

export type CandidateStatusTab = "all" | "未対応" | "進行中" | "面談完了" | "中断・失敗";

interface CandidateStatusTabsProps {
  value: CandidateStatusTab;
  onChange: (next: CandidateStatusTab) => void;
  counts: Record<CandidateStatusTab, number>;
}

const items: { value: CandidateStatusTab; label: string }[] = [
  { value: "all", label: "全て" },
  { value: "未対応", label: "未対応" },
  { value: "進行中", label: "進行中" },
  { value: "面談完了", label: "面談完了" },
  { value: "中断・失敗", label: "中断・失敗" },
];

export function CandidateStatusTabs({ value, onChange, counts }: CandidateStatusTabsProps) {
  return (
    <div
      role="tablist"
      aria-label="候補者ステータス"
      className="flex items-center gap-1 p-1 bg-white border border-slate-200 rounded-lg shadow-sm"
    >
      {items.map((item) => {
        const active = value === item.value;
        const count = counts[item.value];
        return (
          <button
            key={item.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(item.value)}
            className={cn(
              "px-3 py-1.5 rounded-md text-sm font-medium transition-all whitespace-nowrap",
              active
                ? "bg-teal-50 text-teal-700 shadow-sm"
                : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
            )}
          >
            {item.label}
            {count > 0 && (
              <span className={cn("ml-1 text-[10px]", active ? "text-teal-600" : "text-slate-400")}>
                ({count})
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
